/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { EditMode } from './../model/edit-mode.interface';
import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

/**
 * @export
 * @class EditModeService
 */
@Injectable()
export class EditModeService {

  private editModeS: Subject<EditMode>;
  editMode: Observable<EditMode>;

  isEditMode: Boolean;
  editModeMessage: string;

  private editResetModeS: Subject<Boolean>;
  editResetMode: Observable<Boolean>;

  /**
   * Creates an instance of EditModeService.
   *
   * @memberOf EditModeService
   */
  constructor() {
    const editmode = false;
    this.editModeS = new Subject();
    this.editMode = this.editModeS.asObservable();

    this.editResetModeS = new Subject();
    this.editResetMode = this.editResetModeS.asObservable();
  }

  /**
   * @private
   * @param {EditMode} editValue
   *
   * @memberOf EditModeService
   */
  private updateEditMode(editValue: EditMode) {
    this.isEditMode = editValue.status;
    this.editModeMessage = editValue.message;
    this.editModeS.next(editValue);
  }

  /**
   * @param {EditMode} editValue
   *
   * @memberOf EditModeService
   */
  setEditMode(editValue: EditMode) {
    this.updateEditMode(editValue);
  }


  /**
   * @private
   * @param {Boolean} editValue
   *
   * @memberOf EditModeService
   */
  private updateEditResetMode(editValue: Boolean) {
    this.isEditMode = editValue;
    this.editModeMessage = '';
    this.editResetModeS.next(editValue);
  }

  /**
   *
   * @param {Boolean} editValue
   *
   * @memberOf EditModeService
   */
  setEditResetMode(editValue: Boolean) {
    this.updateEditResetMode(editValue);
  }

}
